import { Link } from "react-router-dom";
import useMeta from "@/hooks/useMeta";

export default function NotFound() {
  useMeta("Page not found", "This page doesn't exist. Return to Violet Psychotherapy.");
  return (
    <section className="wrap flex min-h-[65vh] flex-col items-start justify-center py-20" data-testid="not-found-page">
      <img src="/flower-mark.png" alt="" aria-hidden="true" width="96" height="96" className="h-24 w-24" />
      <h1 className="mt-8 text-4xl text-[#22304A] sm:text-5xl lg:text-6xl">This page seems to have wandered off.</h1>
      <p className="mt-5 max-w-lg text-base leading-relaxed text-[#22304A]/80 md:text-lg">The page you're looking for isn't here. Let's take you somewhere calmer.</p>
      <div className="mt-10 flex flex-col gap-3 sm:flex-row">
        <Link to="/" className="btn-primary" data-testid="not-found-home-link">Back to home</Link>
        <Link to="/book" className="btn-ghost" data-testid="not-found-book-link">Book a free intro</Link>
      </div>
    </section>
  );
}
